import { styled } from '@mui/material/styles';
import { TableContainer } from '@mui/material';

export const StyledTableContainer = styled(TableContainer)({
  height: '300px',
});
